import React, { useEffect, useRef } from 'react';
import cloudsIcon from '../../assets/clouds-icon-citron.svg';
import { CUSTOMER_SERVICE_PHONE_NUMBER } from '../../constants';
import { useTranslations } from '../../hooks';
import './ModalError.css';

const errorMessage = `Sorry, we're unable to provide a quote at this time.
Please contact Customer Service at ${CUSTOMER_SERVICE_PHONE_NUMBER} to
purchase a policy.`;

const ModalError = ({
  buttonText = '',
  message = '',
  onButtonClick = () => { },
}) => {
  const buttonRef = useRef(null);
  const { t } = useTranslations('quoting');

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.focus();
    }
  }, []);

  return (
    <div className="Modal-error-container">
      <img
        alt=""
        className="Modal-error-clouds-image"
        src={cloudsIcon}
      />

      <h1 className="Modal-error-title" id="genericError">
        {t('genericModal.errorOccured')}
      </h1>

      <h2 className="Modal-error-description">
        {message || errorMessage}
      </h2>

      <button
        ref={buttonRef}
        aria-label={buttonText}
        className="Modal-error-button"
        onClick={onButtonClick}
        type="button"
      >
        <span className="Modal-error-button-text">
          {buttonText}
        </span>
      </button>
    </div>
  );
};

export default ModalError;
